import { Injectable } from "@angular/core";
import { FormEvent, ItemEvent } from "../components/item/item.model";
import { Field } from "../components/formulario/field.model";
import { BodyRequest, FunctionsAvailable, ItemType } from "../components/formulario/request.model";
import { ExtraFieldsForm, FieldsForm } from "../components/formulario/data-fields";
import { FORM_BUTTONS } from "../components/formulario/form-buttons.config";
import { FormButtonType } from "../components/formulario/formButtonType.enum";
import { ModeType } from "../components/core/core.component";

@Injectable({
  providedIn: 'root'
})
export class FormularioService {

  mode!: ModeType;
  type!: ItemType;
  titleForm!: string;

  constructor() { }

  public loadFormConfig(functionSelected: string, buttons: any[], itemSelected?: BodyRequest, mode?: ModeType, type?: ItemType, titleForm?: string) {
    this.assignProps(mode, type, titleForm);
    functionSelected = this.type.toLowerCase() + functionSelected as FunctionsAvailable;
    this.assignTypeAndItemForm(functionSelected);
    buttons = this.loadButtons(this.mode, buttons);
    let fieldsObject = this.loadFields(this.type, itemSelected!, this.mode, this.titleForm);
    let fields = fieldsObject.fields;
    let extraFields = fieldsObject.extraFields;

    return {fields, extraFields, buttons, titleForm: this.titleForm, mode: this.mode, type: this.type, functionSelected}
  }

  assignProps(mode?: ModeType, type?: ItemType, titleForm?: string) {
    if (mode) {
      this.mode = mode;
    }
    if (type) {
      this.type = type;
    }
    if (titleForm) {
      this.titleForm = titleForm;
    }
  }

  assignTypeAndItemForm(functionSelected: string) {
    functionSelected.includes('Post') ? this.mode = 'Crear' : this.mode = 'Editar';
    this.titleForm = `${this.mode} ${this.type}`;
    if (this.type === ItemType.ASOCIADOS && this.mode === 'Crear') {
      this.type = ItemType.POSTREQUESTASOCIADO;
    }
  }

  loadButtons(mode: string, buttons: any[]) {
    if (buttons.length === 3) {
      buttons.shift();
    }
    mode === 'Crear' ? buttons.unshift(FORM_BUTTONS[FormButtonType.Crear]) : buttons.unshift(FORM_BUTTONS[FormButtonType.Editar]);
    return buttons;
  }

  loadFields(type: ItemType, itemSelected: BodyRequest, mode: string, titleForm: string) {
    let fieldsObject = {
      fields: FieldsForm[type],
      extraFields: ExtraFieldsForm[type]
    }
    // let fields: Field[] = FieldsForm[type];
    // let extraFields: Field[] = ExtraFieldsForm[type];
    // extraFields.forEach(f => fields.push(f));
    if (mode === 'Editar' || (mode === 'Crear' && type === ItemType.HISTORICO)) {
      fieldsObject.fields = this.loadDataFields(fieldsObject.fields, itemSelected);
      let extra = this.loadDataFields(fieldsObject.extraFields, itemSelected);
      fieldsObject.fields.filter((field: Field) => {
        return !field.name.includes('password');
      })
      titleForm = '';
    }
    return fieldsObject;
  }

  // Carga los datos 'valores' del formulario al editar
  loadDataFields(fields: Field[], itemSelected: BodyRequest) {
    return fields.map(field => {
      if (field.name in itemSelected) {
        if (field.type === 'checkbox') {
          return { ...field, value: itemSelected[field.name] === true || Number(itemSelected[field.name]) === 1 };
        }
        return { ...field, value: itemSelected[field.name]?.toString() || (field.options ? 'multiple' : '') };
      }
      return field;
    });
  }

  isItemEvent(obj: any): obj is ItemEvent {
    return obj && typeof obj === 'object' && 'item' in obj && 'type' in obj;
  }

  isFormEvent(obj: any): obj is FormEvent {
    return obj && typeof obj === 'object' && 'item' in obj && 'type' in obj && 'functionSelected' in obj;
  }

}
